import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ImageButton } from 'a/components/StyledComponents';
import svgMap from '../svgs/Common/svgMap';

export const ModalContainer = styled.div`
  width: 1024;
  height: 576;
  overflow: hidden;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
`;

export const HeaderText = styled.h3`
  width: 248;
  color: #ffffff;
  margin: 0 0 10px 0;
  font-family: Quicksand;
  font-size: 24px;
  font-weight: bold;
`;

export const MediumPanel = styled.img`
  position: absolute;
  top: ${({ top }) => top || 112};
  left: ${({ left }) => left || 276};
  object-fit: contain;
`;

export const BigPanel = styled.img`
  position: absolute;
  top: ${({ top }) => top || 62};
  left: ${({ left }) => left || 176};
  object-fit: contain;
`;

export const WidePanel = styled.img`
  position: absolute;
  top: ${({ top }) => top || 112};
  left: ${({ left }) => left || 176};
  object-fit: contain;
`;

export const TitleText = styled.h2`
  margin: 0;
  position: absolute;
  top: ${({ top }) => top || 131};
  left: ${({ left }) => left || 442};
  width: ${({ width }) => width || 142};
  height: ${({ height }) => height || 32};
  font-family: Quicksand Bold;
  color: #ffffff;
  text-align: center;
  font-size: 27px;
  letter-spacing: 1.2px;
  text-align: center;
`;

export const FractionText = styled.div`
  position: absolute;
  top: ${({ top }) => top || 314};
  left: ${({ left }) => left || 362};
  width: 59px;
  height: 42px;
  font-family: Quicksand Bold;
  font-size: 36px;
  text-align: center;
  color: #ffffff;
`;

export const StyledDialogText = styled.div`
  opacity: 0.9;
  font-family: Open Sans;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
`;

export const StyledDescriptionText = styled.div`
  position: absolute;
  top: ${({ top }) => top || 259};
  left: ${({ left }) => left || 486};
  width: 222px;
  height: 135px;
  opacity: 0.9;
  font-family: Open Sans;
  font-size: 16px;
  color: #ffffff;
`;

export const FormattedContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FormattedDescriptionContainer = styled(FormattedContainer)`
  ${({ top, left }) => (top || left ? 'position: absolute;' : '')}
  top: ${({ top }) => top || 259};
  left: ${({ left }) => left || 486};
  width: ${({ width }) => width || 240};
  min-height: 40px;
`;

export const Word = styled.div`
  opacity: 0.9;
  font-family: Open Sans ${({ isBold }) => (isBold ? ' Bold' : '')};
  font-size: 16px;
  color: #ffffff;
  margin-right: ${({ needsMargin }) => (needsMargin ? '5' : '0')};
`;

const StyledContinueButton = styled(ImageButton)`
  top: ${({ top }) => top || '393px'};
  left: ${({ left }) => left || '389px'};
  width: 246px;
  height: 76px;
`;

export const ContinueButton = ({ accessibilityLabel, ...props }) => (
  <StyledContinueButton
    aria-label={accessibilityLabel}
    src={svgMap.ContinueButton}
    {...props}
    data-testid="workshop-modal-continue-button"
  />
);

ContinueButton.propTypes = {
  accessibilityLabel: PropTypes.string,
};

ContinueButton.defaultProps = {
  accessibilityLabel: 'Continue',
};

const StyledCloseModalButton = styled(ImageButton)`
  top: ${({ top }) => top || '125px'};
  left: ${({ left }) => left || '714px'};
  width: 48px;
  height: 48px;
`;

export const CloseModalButton = ({ accessibilityLabel, ...props }) => (
  <StyledCloseModalButton
    aria-label={accessibilityLabel}
    src={svgMap.CloseButton}
    {...props}
  />
);

CloseModalButton.propTypes = {
  accessibilityLabel: PropTypes.string,
};

CloseModalButton.defaultProps = {
  accessibilityLabel: 'Close Modal',
};

export const MediumGreenPanel = props =>
  <MediumPanel src={svgMap.MediumGreenPanel} alt="" {...props} />;

export const MediumBrownPanel = props =>
  (
    <MediumPanel
      src={svgMap.MediumBrownPanel}
      top={112}
      left={276}
      alt=""
      {...props}
    />
  );

export const BigBrownPanel = props =>
  <BigPanel src={svgMap.LargeBrownPanel} alt="" {...props} />;

export const WideGreenPanel = props =>
  <WidePanel src={svgMap.WideGreenPanel} alt="" {...props} />;
